import { useGetPatientsList } from "../../../lib/hooks"
import { useWorkQAutoRefresh } from "../../../lib/hooks/useWorkQAutoRefresh"
import { useLocation, useParams } from "react-router-dom";
import { customWorkQSlugs } from "./custom/globalWorkQStructure";
import { useSelector } from "react-redux";


export default function WorkQComponentBlock({workqSlug}) {
    const location = useLocation()
    const { patientId } = useParams()
    const drawerHasOpened = useSelector(state => state.details.drawerHasOpened)

    if (!workqSlug) {
        customWorkQSlugs.forEach(item => {
            if (location.pathname.includes(item)) {
                workqSlug = item
            }
        })
    }

    const isCustomWorkQ = workqSlug && customWorkQSlugs.includes(workqSlug)
    // Standard queues: skip list fetch on /work-queues/:slug/:id until drawer opens (patient page).
    // Custom queues (police-report, etc.): always load list + details on direct URL.
    const skip = !!patientId && !drawerHasOpened && !isCustomWorkQ
    useGetPatientsList(workqSlug, skip)
    useWorkQAutoRefresh(workqSlug, skip)
    return null
}
